import React, { Component } from 'react';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import { BuscaOrganizacao } from 'ebs-orders-reports-react-lib';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import ModalNewPeriodicalCoordinator from '../../Components/Modal-New-Periodical-Coordinator/Modal-New-Periodical-Coordinator';
import './Periodical-Coordinators.scss';

export default class PeriodicalCoordinators extends Component {

    constructor() {
        super();

        this.Configurations = new Configurations();
        this.getMensageirosEsperanca = this.getMensageirosEsperanca.bind(this);
        this.handleOrg = this.handleOrg.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.finalizaCadastro = this.finalizaCadastro.bind(this);
        this.toggleRemover = this.toggleRemover.bind(this);
        this.confirmarRemover = this.confirmarRemover.bind(this);
        this.remover = this.remover.bind(this);

        this.state = {
            // isLoadingOrg: false,
            isLoadingMensageiros: false,
            hasError: false,
            errorMessage: '',
            listaMensageiros: [],
            isOpenModal: false,
            isLoadingCadastro: false,
            sucessoCadastro: false,

            isLoadingRemover: false,

            modalRemover: false,
            nomeRemover: '',
            idRemover: undefined,
            funcaoRemover: '',
            nivelRemover: '',
            localidadeRemover: '',

            flagRemovido: false,
        };

    }

    handleOrg(eValue) {
        this.setState({ isLoadingMensageiros: true, orgSelecionada: eValue, flagBusca: true, },
            () => {
                this.getMensageirosEsperanca();
            }
        );
    }

    getMensageirosEsperanca() {
        axios.get(this.Configurations.apiBasePath + `/mensageiro-esperanca?organizacao=${this.state.orgSelecionada}`)
            .then(response => {
                let _listaMensageiros = response.data.data.map((item, index) => ({
                    ...item,
                    idOriginal: index,
                }))
                this.setState({
                    listaMensageiros: _listaMensageiros,
                    listaMensageirosOriginal: _listaMensageiros
                })
            })
            .catch(this.handleError)
            .finally(() => {
                this.setState({ isLoadingMensageiros: false })
            })
    }

    handleError(err) { this.setState({ hasError: true, errorMessage: err.response ? err.response.data.message : 'Erro desconhecido.' }) }
    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    toggleModal() {
        this.setState({ isOpenModal: !this.state.isOpenModal, sucessoCadastro: false, cadastroDuplicado: false })
    }

    finalizaCadastro(cadastro) {
        this.setState({ isLoadingCadastro: true })

        axios.post(this.Configurations.apiBasePath + `/mensageiro-esperanca`, cadastro)
            .then(response => {
                if (!response.data.success) {
                    this.setState({ cadastroDuplicado: true })
                }
                else this.setState({ sucessoCadastro: true }, () => this.getMensageirosEsperanca())
            })
            .catch(err => {
                this.handleError(err)
                this.setState({ sucessoCadastro: false })
            })
            .finally(() => {
                this.setState({ isLoadingCadastro: false })
            })
    }

    toggleRemover() {
        this.setState({
            modalRemover: !this.state.modalRemover,
        }, () => {
            if (!this.state.modalRemover) this.setState({ nomeRemover: '' })
            if (this.state.flagRemovido) this.setState({ flagRemovido: false })
        })
    }

    confirmarRemover(_id) {
        this.setState({
            nomeRemover: _id !== undefined ? this.state.listaMensageirosOriginal[_id].nome : '',
            idRemover: _id,
            funcaoRemover: _id !== undefined ? this.state.listaMensageirosOriginal[_id].funcao : '',
            nivelRemover: _id !== undefined ? this.state.listaMensageirosOriginal[_id].nivelNome : '',
            localidadeRemover: _id !== undefined ? this.state.listaMensageirosOriginal[_id].localidade : '',
        }, () => {
            this.toggleRemover();
        })
    }

    remover() {
        const _usuario = this.state.listaMensageirosOriginal[this.state.idRemover],
            _bodyExclusao = [{
                idCoordImpresso: _usuario.idCoordImpresso
            }]
        this.setState({
            isLoadingRemover: true,
        }, () => {
            axios.put(this.Configurations.apiBasePath + `/mensageiro-esperanca`, _bodyExclusao, { noLoading: true })
                .then(response => {
                    this.setState({
                        flagRemovido: true,
                        nomeRemover: '',
                        idRemover: undefined,
                        funcaoRemover: '',
                        nivelRemover: '',
                        localidadeRemover: '',
                    }, () => this.getMensageirosEsperanca())
                })
                .catch(this.handleError)
                .finally(() => { this.setState({ isLoadingRemover: false }) });
        })
    }

    render() {

        const {
            isLoadingMensageiros, orgSelecionada, flagBusca,
            listaMensageiros,
            hasError, errorMessage,
            isOpenModal, sucessoCadastro, isLoadingCadastro, cadastroDuplicado
        } = this.state;

        return (
            <div className="periodical-coordinators">
                <div className="row px-2 px-lg-4 no-gutters">
                    <div className="col-12">
                        <div className="row no-gutters py-3 border-bottom border-info">
                            <div className="col-12 text-center text-lg-left">
                                <h4 className="m-0">Coordenadores de Periódicos</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="row no-gutters d-flex align-items-end">
                            <div className="col-7">
                                <div className="row no-gutters">
                                    <div className="col-12 pt-2 pb-1">
                                        <p className="m-0">Selecione a organização:</p>
                                    </div>
                                    <div className="col-12 py-1">
                                        <BuscaOrganizacao handleOrg={this.handleOrg} orgSelecionada={orgSelecionada} apiBasePath={this.Configurations.apiBasePath} tokenKey={this.Configurations.tokenKey} isLoadingAPI={isLoadingMensageiros * flagBusca} />
                                    </div>
                                </div>
                            </div>
                            {flagBusca && (
                                <div className="col-5 text-right py-1">
                                    <button onClick={this.toggleModal} className="btn btn-outline-success">novo cadastro</button>
                                </div>
                            )}
                        </div>
                    </div>
                    {isLoadingMensageiros ? (
                        <div className="col-12 my-3 text-center">
                            <div className="spinner-border text-success" />
                        </div>
                    ) : (
                            <div className="col-12 py-2">
                                <div className="row no-gutters">
                                    {listaMensageiros && listaMensageiros.length > 0 && (
                                        <div className="col-12 py-2">
                                            <table className="table table-striped bg-white border">
                                                <thead>
                                                    <tr>
                                                        <th>Nome</th>
                                                        <th>Divisão</th>
                                                        <th>Cód.</th>
                                                        <th>Função</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {listaMensageiros.map((item, index) => {
                                                        const _idOriginal = item.idOriginal,
                                                            { nome, divisao, codMembro, funcao, nivelNome, localidade } = item;
                                                        return (
                                                            <tr key={`mensageiro-${index}`}>
                                                                <td>
                                                                    <a target="_blank" rel="noopener noreferrer" href={`/pedidos/membro/${codMembro}`}>{nome}</a>
                                                                </td>
                                                                <td>{divisao}</td>
                                                                <td>{codMembro}</td>
                                                                <td>{funcao} - {nivelNome} {localidade}</td>
                                                                <td onClick={() => this.confirmarRemover(_idOriginal)} className="text-center cursor-pointer"><i className={`far fa-trash-alt text-danger`}></i></td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                    {flagBusca && listaMensageiros.length === 0 && (
                                        <div className="col-12 py-2">
                                            <p>Não existem coordenadores cadastrados nessa organização.</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                </div>
                <Modal isOpen={this.state.modalRemover} toggle={this.toggleRemover}>
                    <ModalHeader toggle={this.toggleRemover}>Confirmação da exclusão</ModalHeader>
                    <ModalBody>
                        {this.state.flagRemovido ? (
                            <p className="m-0">Função removida com sucesso.</p>
                        ) : (
                                <p className="m-0">Deseja remover a função de <strong>{this.state.funcaoRemover} ({this.state.nivelRemover} {this.state.localidadeRemover}) </strong> de <strong>{this.state.nomeRemover}</strong>?</p>
                            )}
                    </ModalBody>
                    <ModalFooter>
                        <div className="row no-gutters w-100">
                            <div className="col-12">
                                {this.state.isLoadingRemover ? (
                                    <div className="row no-gutters w-100 text-center">
                                        <div className="col-12">
                                            <div className="spinner-border text-success" />
                                        </div>
                                    </div>
                                ) : (
                                        <div className="row no-gutters w-100 text-right">
                                            {this.state.flagRemovido ? (
                                                <div className="col-12 text-right">
                                                    <Button color="secondary" onClick={this.toggleRemover}>ok</Button>
                                                </div>
                                            ) : (
                                                    <div className="col-12">
                                                        <Button onClick={this.remover} disabled={this.state.isLoadingRemover} color="danger">confirmar</Button>
                                                        {' '}<Button color="secondary" disabled={this.state.isLoadingRemover} onClick={this.toggleRemover}>voltar</Button>
                                                    </div>
                                                )}
                                        </div>
                                    )}
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>
                <ErrorModal isOpen={hasError} message={errorMessage} closeErrorModal={this.closeErrorModal} />
                <ModalNewPeriodicalCoordinator
                    toggle={this.toggleModal}
                    isOpen={isOpenModal}
                    finalizaCadastro={this.finalizaCadastro}
                    sucessoCadastro={sucessoCadastro}
                    isLoadingCadastro={isLoadingCadastro}
                    orgSelecionada={orgSelecionada}
                    cadastroDuplicado={cadastroDuplicado}
                    novaBusca={() => this.setState({ cadastroDuplicado: false })}
                />
            </div >
        )
    }
}